<template>
<div class="embed-responsive embed-responsive-1by1" :id="mapName"></div>
</template>

<script>

// Purely used to update map about postcode change
import EventBus from '../events/event-bus'

export default {
  name: 'google-map',
  props: ['name', 'postcode'],
  data: function() {
    return {
      mapName: this.name + "-map",
      markerCoordinates: [{
        latitude: '',
        longitude: ''
      }],
      map: null,
      markers: [],
      marker: null
    }
  },

	created() {
		var self = this
	  EventBus.$on('postcodeChange', function(postcode){
			self.codeAddress(postcode);
		})
	},

  mounted: function() {
    const element = document.getElementById(this.mapName)
    const mapCentre = this.markerCoordinates[0]
    const centerPos = new google.maps.LatLng(mapCentre.latitude, mapCentre.longitude)
    const options = {
      center: centerPos,
      zoom: 11
    }

    this.map = new google.maps.Map(element, options);

    this.marker = new google.maps.Marker({
      position: centerPos,
      title: "You are here!"
    });

    this.marker.setMap(this.map);

    if (this.postcode) {
      this.codeAddress(this.postcode)
    }

  },

  // watch: {
  //   postcode(postcode, oldPostcode) {
  //     this.codeAddress(postcode)
  //   }
  // },

  methods: {
    codeAddress(postcode) { /**/
      var self = this;
      var geocoder = new google.maps.Geocoder();

      geocoder.geocode({
          componentRestrictions: {
            country: 'GB'
          },
          'address': postcode
        },
        function(results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            var loc = results[0].geometry.location;

            var lat = loc.lat();
            var lng = loc.lng();

            if (self.map) {
              var myLatlng = {
                lat: lat,
                lng: lng
              };
              self.map.panTo(myLatlng);
              self.marker.setPosition(myLatlng);
              self.map.setZoom(16);
            }
          }
        });
    },
  }
};
</script>
